const setAuthenticatedUserToken = () => {
	const customerGUID = window?.dataLayer[0]?.userInfo?.customerGUID;
	if (window?.od?.userLoggedIn && customerGUID !== undefined) {
		window?.aa('setAuthenticatedUserToken', customerGUID);
	}
};

export default setAuthenticatedUserToken;
